/**
 * Generic Yes/No options for a boolean enum column.
 */
export const YES = Object.freeze({ value: true, label: 'Yes' })
export const NO = Object.freeze({ value: false, label: 'No' })

export const yesNoOptions = Object.freeze([YES, NO])
